import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ArticoliCategorie, ArticoliCategorieTable, ModelNumStrNav } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class ArticoliCategorieService extends CrudGenericsService<ArticoliCategorie, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ArticoliCategorie`);
    this.base = `${env.apiUrl}/api/ArticoliCategorie/`;
  }
  Get4Select_SubCatCategorieNavigation(): Observable<ModelNumStrNav[]> {
    const u = this.base + 'Get4Select_SubCatCategorieNavigation';
    return this.http.get<ModelNumStrNav[]>(`${u}`);
  }
  GetArticoliCategorieTable(): Observable<ArticoliCategorieTable[]> {
    const u = this.base + 'GetArticoliCategorieTable';
    return this.http.get<ArticoliCategorieTable[]>(`${u}`);
  }
}
